import { MenuProps } from 'antd'
import { RichPromotionPage } from 'components/goods/RichPromotion/RichPromotionPage'
import {
  ApiOutlined,
  CarOutlined,
  EnvironmentOutlined,
  IdcardOutlined,
  ImportOutlined,
  MessageOutlined,
  NotificationOutlined,
  PercentageOutlined,
  StarOutlined,
  StockOutlined,
  TagOutlined,
  TeamOutlined
} from '@ant-design/icons'
import { Navigate, createBrowserRouter } from 'react-router-dom'
import { GoodsAdd } from 'pages/admin/Goods/Add/Add'
import { GoodsEdit } from 'pages/admin/Goods/Edit/Edit'
import { ProfileInfo } from 'pages/admin/Profile/Info'
import { ProfileShops } from 'pages/admin/Profile/Shops'
import { ProfileDelivery } from 'pages/admin/Profile/Delivery'
import { ProfileAccounting } from 'pages/admin/Profile/Accounting'
import { ProfileApiMoySklad } from 'pages/admin/Profile/ApiMoySklad'
import { ProfileApiOneC } from 'pages/admin/Profile/ApiOneC'
import { ProfileApiInsales } from 'pages/admin/Profile/ApiInsales'
import { ProfileNotifications } from 'pages/admin/Profile/Notifications'
import { ProfileEmployees } from 'pages/admin/Profile/Employees'
import { AppWrapper } from 'components/layout/AppWrapper/AppWrapper'
import { adminRoutes } from 'shared/constants/routes'
import { SellerWrapper } from 'components/sellers/SellerWrapper/SellerWrapper'
import { GoodsList } from 'pages/admin/Goods/List/GoodsList'
import { MyHorses } from 'pages/admin/Horses/MyHorses'
import { MyHorse } from 'pages/admin/Horses/MyHorse'
import { Orders } from 'pages/admin/Orders/Orders'
import { Order } from 'pages/admin/Orders/Order/Order'
import { ProfilePromocodesList } from 'pages/admin/Profile/Promocodes'
import { ProfileMassImport } from 'pages/admin/Profile/MassImport'
import { ProfileChats } from 'pages/admin/Profile/Chats'
import { ProfileReviews } from 'pages/admin/Profile/Reviews'
import { AiGoodsList } from 'pages/admin/AiGoods/List/AiGoodsList'
import { AiGoodsEdit } from 'pages/admin/AiGoods/Edit/AiGoodsEdit'
import { AiGoodsCreate } from 'pages/admin/AiGoods/Create/AiGoodsCreate'
import { PromoCodesCreate } from 'pages/admin/PromoCodes/Create/PromoCodesCreate'
import { PromoCodesEdit } from 'pages/admin/PromoCodes/Edit/PromoCodesEdit'
import { ProfileDiscountsList } from 'pages/admin/Profile/Discounts'
import { DiscountsCreate } from 'pages/admin/Discounts/Create/DiscountsCreate'
import { DiscountsEdit } from 'pages/admin/Discounts/Edit/DiscountsEdit'

const sellerLinks: MenuProps['items'] = [
  {
    label: 'Основная информация',
    key: adminRoutes.PROFILE_INFO,
    icon: <IdcardOutlined />,
    itemIcon: <span style={{ color: 'red' }}> *</span>
  },
  {
    label: 'Сообщения',
    key: adminRoutes.PROFILE_CHATS,
    icon: <MessageOutlined />
  },
  {
    label: 'Адреса магазинов',
    key: adminRoutes.PROFILE_SHOPS,
    icon: <EnvironmentOutlined />,
    itemIcon: <span style={{ color: 'red' }}> *</span>
  },
  {
    label: 'Способы доставки',
    key: adminRoutes.PROFILE_DELIVERY,
    icon: <CarOutlined />,
    itemIcon: <span style={{ color: 'red' }}> *</span>
  },
  {
    label: 'Бухгалтерия',
    key: adminRoutes.PROFILE_ACCOUNTING,
    icon: <StockOutlined />
  },
  {
    label: 'Сотрудники',
    key: adminRoutes.PROFILE_EMPLOYEES,
    icon: <TeamOutlined />
  },
  {
    label: 'Уведомления',
    key: adminRoutes.PROFILE_NOTIFICATIONS,
    icon: <NotificationOutlined />
  },
  {
    label: 'Массовый импорт',
    key: adminRoutes.PROFILE_MASS_IMPORT,
    icon: <ImportOutlined />
  },
  {
    label: 'API Синхронизация',
    key: 'api',
    icon: <ApiOutlined />,
    children: [
      {
        label: '1С Синхронизация',
        key: adminRoutes.PROFILE_API_ONE_C
      },
      {
        label: 'Мой склад',
        key: adminRoutes.PROFILE_API_MOYSKLAD
      },
      {
        label: 'InSales',
        key: adminRoutes.PROFILE_API_INSALES
      }
    ]
  },
  {
    label: 'Промокоды',
    key: adminRoutes.PROFILE_PROMOCODES,
    icon: <TagOutlined />
  },
  {
    label: 'Скидки',
    key: adminRoutes.PROFILE_DISCOUNTS,
    icon: <PercentageOutlined />
  },
  {
    label: 'Отзывы',
    key: adminRoutes.PROFILE_REVIEWS,
    icon: <StarOutlined />
  }
]

export const adminRouter = createBrowserRouter([
  {
    path: '/',
    element: <AppWrapper />,
    children: [
      {
        // стартовый раздел — заказы: с них начинают работу и продавец, и админ
        index: true,
        element: <Navigate to={adminRoutes.ORDERS} />
      },
      {
        path: adminRoutes.GOODS,
        element: <GoodsList />
      },
      {
        path: adminRoutes.GOODS_ADD,
        element: <GoodsAdd />
      },
      {
        path: adminRoutes.GOODS_EDIT,
        element: <GoodsEdit />
      },
      { path: '/goods/edit/:id/promotion', element: <RichPromotionPage /> },
      {
        path: adminRoutes.HORSES,
        element: <MyHorses />
      },
      {
        path: adminRoutes.HORSE,
        element: <MyHorse />
      },
      {
        path: adminRoutes.ORDERS,
        element: <Orders />
      },
      {
        path: adminRoutes.ORDER,
        element: <Order />
      },
      {
        path: adminRoutes.AI_GOODS,
        element: <AiGoodsList />
      },
      {
        path: adminRoutes.AI_GOODS_EDIT,
        element: <AiGoodsEdit />
      },
      {
        path: adminRoutes.AI_GOODS_CREATE,
        element: <AiGoodsCreate />
      },
      {
        path: adminRoutes.PROMOCODES_CREATE,
        element: <PromoCodesCreate />
      },
      {
        path: adminRoutes.PROMOCODES_EDIT,
        element: <PromoCodesEdit />
      },
      {
        path: adminRoutes.DISCOUNTS_CREATE,
        element: <DiscountsCreate />
      },
      {
        path: adminRoutes.DISCOUNTS_EDIT,
        element: <DiscountsEdit />
      },
      {
        path: adminRoutes.PROFILE,
        element: (
          <SellerWrapper
            type='profile'
            links={sellerLinks}
            autoCollapseKeys={[
              adminRoutes.PROFILE_PROMOCODES,
              adminRoutes.PROFILE_DISCOUNTS,
              adminRoutes.PROFILE_CHATS
            ]}
          />
        ),
        children: [
          {
            index: true,
            element: <Navigate to={adminRoutes.PROFILE_INFO} />
          },
          {
            path: adminRoutes.PROFILE_INFO,
            element: <ProfileInfo />
          },
          {
            path: adminRoutes.PROFILE_SHOPS,
            element: <ProfileShops />
          },
          {
            path: adminRoutes.PROFILE_DELIVERY,
            element: <ProfileDelivery />
          },
          {
            path: adminRoutes.PROFILE_ACCOUNTING,
            element: <ProfileAccounting />
          },
          {
            path: adminRoutes.PROFILE_EMPLOYEES,
            element: <ProfileEmployees />
          },
          {
            path: adminRoutes.PROFILE_MASS_IMPORT,
            element: <ProfileMassImport />
          },
          {
            path: adminRoutes.PROFILE_API_ONE_C,
            element: <ProfileApiOneC />
          },
          {
            path: adminRoutes.PROFILE_API_MOYSKLAD,
            element: <ProfileApiMoySklad />
          },
          {
            path: adminRoutes.PROFILE_API_INSALES,
            element: <ProfileApiInsales />
          },
          {
            path: adminRoutes.PROFILE_NOTIFICATIONS,
            element: <ProfileNotifications />
          },
          {
            path: adminRoutes.PROFILE_PROMOCODES,
            element: <ProfilePromocodesList />
          },
          {
            path: adminRoutes.PROFILE_DISCOUNTS,
            element: <ProfileDiscountsList />
          },
          {
            path: adminRoutes.PROFILE_CHATS,
            element: <ProfileChats />
          },
          {
            path: adminRoutes.PROFILE_REVIEWS,
            element: <ProfileReviews />
          }
        ]
      },
      {
        path: '*',
        element: <Navigate to='/' replace />
      }
    ]
  }
])
